import { Alert, Button } from "antd";

export default function NotificationsLoadError({ error, onRetry }) {
  return (
    <div style={{ padding: 12 }}>
      <Alert
        type="error"
        showIcon
        message="Impossible de charger les notifications"
        description={typeof error === "string" ? error : undefined}
        action={
          <Button size="small" onClick={onRetry}>
            Réessayer
          </Button>
        }
      />
    </div>
  );
}
